var Quaternion = (function () {
    function Quaternion() {
    }
    return Quaternion;
}());
export { Quaternion };
